import formatDistanceStrict from 'date-fns/formatDistanceStrict'
import h from 'hyperscript'

import callout from '../../_components/callout/callout'
import Dialog from '../../_components/dialog/dialog'
import { PRICING } from '../config'
import { latestMacReleaseOnDate } from '../helpers/releases'

const { ready } = require('../base/utils')

async function expirationStatusFromURL() {
  const params = new URLSearchParams(window.location.search)
  if (params.has('expiration_date')) {
    const expirationTimestamp = parseInt(params.get('expiration_date'))
    const isExpired = expirationTimestamp <= new Date().getTime() / 1000
    return {
      expirationTimestamp,
      isExpired,
    }
  }

  return {}
}

/**
 *
 * @param {ReleaseData} release
 * @param {License} license
 */
function createExpiredCallout(lastRelease) {
  const title = 'Expired license? Here are your options.'

  const options = []
  const actions = []

  const releaseDateDistance = formatDistanceStrict(lastRelease['release-date'], new Date(), { addSuffix: true })
  options.push(
    h('p', [
      h('strong', `Download version ${lastRelease.version} of the Mac app`),
      `, released ${releaseDateDistance}, and keep using it for as long as you’d like. Or any `,
      h('a', { href: '/releases/mac/' }, 'older version.'),
    ])
  )
  actions.push({ label: `Download Sketch ${lastRelease.version}`, href: lastRelease.url, primary: true })

  options.push(
    h('p', [
      h('strong', `Get the latest version`),
      `, continuous updates, a shared workspace, and easy team management, with a subscription from $${PRICING.SUBSCRIPTION.MONTHLY}/month.`,
    ])
  )
  actions.push({
    label: 'Learn about switching to a subscription',
    href: `/support/general/account/switch-to-subscription/`,
  })

  const bar = callout({
    title,
    body: options,
    actions,
    footer: h('p', [
      'Questions? ',
      h('a', { href: '/pricing/' }, 'See pricing'),
      ' or ',
      h('a', { href: '/support/' }, 'get help'),
      '.',
    ]),
  })
  return bar
}

function showExpiredDialog(lastRelease, license) {
  const expiredDialog = new Dialog({
    content: createExpiredCallout(lastRelease, license),
    hasContainer: true,
    overlayModifiers: 'prism',
  })
  expiredDialog.show()
}

ready(async function () {
  const { expirationTimestamp, isExpired, license } = await expirationStatusFromURL()

  if (isExpired !== true) return

  const lastRelease = await latestMacReleaseOnDate(expirationTimestamp)

  showExpiredDialog(lastRelease, license)
})
